const BASE_URL = 'https://api.getvisitapp.com/v4';
const BACKEND_TS_BASE_URL = 'https://api.getvisitapp.com/v5';
const PHARMACY_SERVICE_URL = 'https://api.getvisitapp.com/pharmacy';
const NETWORK_SERVICE_URL = 'https://network.getvisitapp.com';
const KEA_APP_URL = 'https://kea.getvisitapp.com/vision';
const OPS_DASHBOARD_URL = 'https://operations.getvisitapp.com/';
const MAORI_DASHBOARD_URL = 'https://maori.getvisitapp.com/';
const CATALYST_DASHBOARD_URL = 'https://catalyst.getvisitapp.com/welcome';
const DOCTOR_DASHBOARD_URL = 'https://doctors.getvisitapp.com/home/';
const PAYMENT_SERVICE_URL = 'https://payments.getvisitapp.com';

const production = {
  baseUrl: BASE_URL,
  backendTsBaseUrl: BACKEND_TS_BASE_URL,
  pharmacyService: PHARMACY_SERVICE_URL,
  networkService: NETWORK_SERVICE_URL,
  keaAppUrl: KEA_APP_URL,
  pubnub: {
    publishKey: 'pub-c-fb8ac7e3-75bf-4396-bf14-77215f8b9419',
    subscribeKey: 'sub-c-78deef00-680f-11e5-a57f-0619f8945a4f',
  },
  googleAuthConfig: {
    clientId:
      '587654000125-r26coedb1f9siqfgn1arj63k3dslrqqk.apps.googleusercontent.com',
    scopes: ['email', 'profile', 'openid'],
  },
  opsDashboardURL: OPS_DASHBOARD_URL,
  maoriDashboardURL: MAORI_DASHBOARD_URL,
  catalystDashboardURL: CATALYST_DASHBOARD_URL,
  doctorDashboardUrl: DOCTOR_DASHBOARD_URL,
  paymentServiceUrl: PAYMENT_SERVICE_URL,
  starHealthAccess: {
    allowedUserIds: [
      '839', '397', '781', '29', '63', '62', '354', '1067', '1041', '81', '1111', '544', '263', '298', '941', '1461', '1508', '1757',
      // Add your allowed userIds here
    ],
  },
  pacAccess: {
    allowedUserIds: [
      '3', '357', '665', '784', '1005',
      // Add your allowed userIds here
    ],
  },
};

export default production;
